<li class="text-gray text-2xl text-center px-2 md:px-8 py-2">
  <div class="flex">
    <img src="/img/landing-page/yep.png" alt="checkmark" class="w-8 h-8" />
    <div class="ml-2 text-center">
      <slot />
    </div>
  </div>
</li>
